import React from 'react';

// Constellation
import { IconCheckmark } from '@zillow/constellation';

// Components
import Slide from './Slide';

// Utils
import { gaEvents } from 'app/shared/constants/AnalyticsConstants';
import Images from './images';
import zrmPathsManifest from 'app/shared/utils/zrmPathsManifest';

const paths = zrmPathsManifest.getAllPaths();
const iconStyles = {
  marginTop: 0,
  marginRight: 8,
  marginBottom: 4,
  minWidth: 24,
};

function getTiles(gaTrackingCategory: string) {
  return [
    <Slide
      heading="Post a rental listing"
      key="Post a rental listing"
      body="Easy-to-use tools let you list your property where millions of renters search each month. Plus, messaging and tenant screening are integrated into our listing platform to help you find and screen applicants faster."
      imgPosition="right"
      btnPrimaryEvent={{ ...gaEvents.ZRM_UPSELL_POST_LISTING, category: gaTrackingCategory }}
      btnPrimaryLabel="Get started"
      btnPrimaryHref={`${paths.propertiesPage}?postingPath=true`}
      btnSecondaryEvent={{ ...gaEvents.ZRM_UPSELL_POST_LISTING_LEARN_MORE, category: gaTrackingCategory }}
      btnSecondaryLabel="Learn more"
      btnSecondaryHref={paths.postAListingPage}
      srcBackground={Images.TileOneImage}
      srcOverlay={Images.TileOneOverlay}
    />,
    <Slide
      heading="Screen tenants with online rental applications"
      key="Screen tenants with online rental applications"
      body="Sign your next tenant with confidence using our online rental applications. Save time with credit reports, background checks and eviction history for each applicant – all in one place"
      imgPosition="left"
      btnPrimaryEvent={{ ...gaEvents.ZRM_UPSELL_SCREEN_TENANTS, category: gaTrackingCategory }}
      btnPrimaryLabel="Get started"
      btnPrimaryHref={`${paths.propertiesPage}?mktPath=applications`}
      btnSecondaryEvent={{ ...gaEvents.ZRM_UPSELL_SCREEN_TENANTS_LEARN_MORE, category: gaTrackingCategory }}
      btnSecondaryLabel="Learn more"
      btnSecondaryHref="https://www.zillow.com/z/rental-manager/tenant-screening/"
      srcBackground={Images.TileTwoImage}
      srcOverlay={Images.TileTwoOverlay}
    />,
    <Slide
      heading="Sign a rental lease"
      key="Sign a rental lease"
      body="Create your rental lease using an online lease builder and templates drafted with local law firms, and e-sign it with your renters."
      imgPosition="right"
      btnPrimaryEvent={{ ...gaEvents.ZRM_UPSELL_SIGN_LEASE, category: gaTrackingCategory }}
      btnPrimaryLabel="Create a lease"
      btnPrimaryHref={`${paths.selectPropertyPage}?type=leases`}
      btnSecondaryEvent={{ ...gaEvents.ZRM_UPSELL_SIGN_LEASE_LEARN_MORE, category: gaTrackingCategory }}
      btnSecondaryLabel="Learn more"
      btnSecondaryHref="https://www.zillow.com/z/rental-manager/rental-lease-agreements/"
      srcBackground={Images.TileThreeImage}
      srcOverlay={Images.TileThreeOverlay}
    />,
    <Slide
      heading="Collect rent payments"
      key="Collect rent payments"
      body="The convenient way for landlords to get paid. Rent, utilities, move-in fees and more are deposited straight into your bank account — at no cost to you."
      imgPosition="left"
      btnPrimaryLabel="Get paid"
      btnPrimaryEvent={{ ...gaEvents.ZRM_UPSELL_COLLECT_RENT, category: gaTrackingCategory }}
      btnPrimaryHref={`${paths.selectPropertyPage}?type=payments`}
      btnSecondaryEvent={{ ...gaEvents.ZRM_UPSELL_COLLECT_RENT_LEARN_MORE, category: gaTrackingCategory }}
      btnSecondaryLabel="Learn more"
      btnSecondaryHref="https://www.zillow.com/z/rental-manager/collect-rent-online/"
      srcBackground={Images.TileFourImage}
      srcOverlay={Images.TileFourOverlay}
    />,
    <Slide
      heading="List your rental for free"
      key="List your rental for free"
      body={
        <>
          <strong style={{ marginBottom: 8, display: 'inline-block' }}>Every listing includes:</strong>
          <br />
          <div style={{ display: 'flex' }}>
            <IconCheckmark fontColor="brand" size="sm" style={iconStyles} />
            Posting to Zillow, Trulia and Hotpads
          </div>
          <div style={{ display: 'flex' }}>
            <IconCheckmark fontColor="brand" size="sm" style={iconStyles} />
            Tenant screening with background and other credit checks
          </div>
          <div style={{ display: 'flex' }}>
            <IconCheckmark fontColor="brand" size="sm" style={iconStyles} />
            Online leases
          </div>
          <div style={{ display: 'flex' }}>
            <IconCheckmark fontColor="brand" size="sm" style={iconStyles} />
            Online rent payments
          </div>
        </>
      }
      imgPosition="right"
      btnPrimaryEvent={{ ...gaEvents.ZRM_UPSELL_FREE_LISTING, category: gaTrackingCategory }}
      btnPrimaryLabel="Get started"
      btnPrimaryHref={`${paths.propertiesPage}?postingPath=true`}
      srcBackground={Images.TileFiveImage}
    />,
  ];
}

export default getTiles;
